
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/solutions",
      function () {
        return require("private-next-pages/[lang]/solutions/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/solutions"])
      });
    }
  